module.exports = __webpack_public_path__ + "img/phoneBanner8.537f2d5c.jpg";